module.exports = __webpack_public_path__ + "img/zqsy.f082921f.jpg";